import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  paper: {
    padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100px',
  },
  mapContainer: {
    height: '84vh', width: '100%', marginTop: '2rem',
  },
  markerContainer: {
    position: 'absolute', transform: 'translate(-50%, -50%)', zIndex: 50, '&:hover': { zIndex: 50 },
  },
  pointer: {
    cursor: 'pointer',
  },
}));